import { useApp } from "@/App";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFetch } from "@/lib/hooks";
import { api } from "@/lib/api";
import { ArrowLeftRight, Package, Plus, User, RefreshCw } from "lucide-react";

export function Header() {
	const { currentUserId, setCurrentUserId, navigate } = useApp();
	const { data: users } = useFetch(() => api.users.list(), []);

	return (
		<header className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
			<div className="container mx-auto px-4 max-w-7xl">
				<div className="flex h-16 items-center justify-between">
					<button
						onClick={() => navigate("/")}
						className="flex items-center gap-2 hover:opacity-80 transition-opacity"
					>
						<div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground">
							<RefreshCw className="h-5 w-5" />
						</div>
						<div className="flex flex-col">
							<span className="text-lg font-bold leading-tight tracking-tight">SwapChain</span>
							<span className="text-[10px] text-muted-foreground leading-none">barter marketplace</span>
						</div>
					</button>

					<nav className="hidden md:flex items-center gap-1">
						<Button variant="ghost" size="sm" onClick={() => navigate("/browse")}>
							<Package className="h-4 w-4 mr-1.5" />
							Browse
						</Button>
						<Button variant="ghost" size="sm" onClick={() => navigate("/swaps")}>
							<ArrowLeftRight className="h-4 w-4 mr-1.5" />
							My Swaps
						</Button>
						<Button variant="ghost" size="sm" onClick={() => navigate("/profile")}>
							<User className="h-4 w-4 mr-1.5" />
							Profile
						</Button>
						<Button size="sm" onClick={() => navigate("/list")} className="ml-2">
							<Plus className="h-4 w-4 mr-1.5" />
							List Item
						</Button>
					</nav>

					<div className="flex items-center gap-3">
						<div className="flex md:hidden items-center gap-1">
							<Button variant="ghost" size="icon" onClick={() => navigate("/browse")}>
								<Package className="h-4 w-4" />
							</Button>
							<Button variant="ghost" size="icon" onClick={() => navigate("/swaps")}>
								<ArrowLeftRight className="h-4 w-4" />
							</Button>
							<Button variant="ghost" size="icon" onClick={() => navigate("/profile")}>
								<User className="h-4 w-4" />
							</Button>
							<Button size="icon" onClick={() => navigate("/list")}>
								<Plus className="h-4 w-4" />
							</Button>
						</div>
						<Select value={currentUserId} onValueChange={setCurrentUserId}>
							<SelectTrigger className="w-[160px] h-9 text-xs">
								<SelectValue />
							</SelectTrigger>
							<SelectContent>
								{users?.map((u) => (
									<SelectItem key={u.id} value={u.id} className="text-xs">
										{u.displayName}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
					</div>
				</div>
			</div>
		</header>
	);
}
